var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrowth(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 75.81 115.42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: url(#linear-gradient-2);\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5 {\r\n        stroke: #fff;\r\n        stroke-linejoin: round;\r\n      }\r\n\r\n      .cls-1, .cls-2, .cls-3, .cls-5 {\r\n        fill-opacity: .25;\r\n        stroke-linecap: round;\r\n        stroke-width: .82px;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: url(#linear-gradient-4);\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: url(#linear-gradient-3);\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: none;\r\n        stroke-width: 2.01px;\r\n      }\r\n\r\n      .cls-5 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 71.13,
    y1: 100.83,
    x2: 2.72,
    y2: 101.16,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#fff",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#fff",
    stopOpacity: 0.73
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "#fff",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#fff",
    stopOpacity: 0.46
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#fff",
    stopOpacity: 0.37
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#fff",
    stopOpacity: 0.3
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#fff",
    stopOpacity: 0.26
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.25
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 71.12,
    y1: 99.1,
    x2: 2.71,
    y2: 99.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 71.1,
    y1: 93.94,
    x2: 2.68,
    y2: 94.26,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 71.04,
    y1: 81.38,
    x2: 2.62,
    y2: 81.71,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m11.06,87.23v27.77H1.01v-27.66h5.76c1.44,0,2.87-.04,4.29-.12h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m31.18,83.56v31.44h-10.06v-28.79c3.46-.65,6.81-1.54,10.06-2.64h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m51.29,73.07v41.94h-10.06v-35.6c3.57-1.85,6.93-3.97,10.06-6.35h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m71.4,47.76v67.25h-10.06v-51.09c4.21-4.85,7.62-10.29,10.06-16.16h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m74.8,26.51h-9.14c-.06,5.86-1.25,11.7-3.54,17.15-2.02,4.81-4.87,9.33-8.46,13.43-2.47,2.82-5.29,5.43-8.37,7.75-2.71,2.03-5.63,3.86-8.71,5.44-2.73,1.39-5.59,2.59-8.52,3.59-2.85.96-5.81,1.73-8.8,2.29-2.83.53-5.72.87-8.6,1.03-1.27.07-2.54.11-3.79.11H1.01v-10.56h5.8c1.06,0,2.14-.03,3.21-.09,2.42-.14,4.85-.43,7.23-.87,2.49-.47,4.97-1.11,7.34-1.91,2.45-.82,4.83-1.82,7.08-2.97,2.54-1.3,4.95-2.8,7.17-4.47,2.49-1.88,4.78-3.99,6.78-6.26,2.84-3.24,5.08-6.8,6.67-10.56,1.76-4.2,2.68-8.6,2.72-13.09h-9.64L60.08,1.01l14.73,25.5Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowth);
export default __webpack_public_path__ + "static/media/growth.ee5d470722b364c7381a1644cb095864.svg";
export { ForwardRef as ReactComponent };